/**
 * useEntitlement — does the tenant's plan include this (Phase 16A)?
 *
 * Entitlements come from GET /users/me/permissions (billing/plans.js on the server, the single
 * source). While permissions load, or from an older backend, every entitlement reads false.
 * The server enforces the same rule; this only decides what the UI offers.
 *
 * @module hooks/useEntitlement
 */
import { useAuth } from '../context/authcontext';
import type { PlanEntitlements } from '../types/permissions';

export const useEntitlement = (key: keyof PlanEntitlements): boolean => {
  const { user } = useAuth();
  return user?.entitlements?.[key] === true;
};

export default useEntitlement;
